<template>
  <div>

    <QuestionFormEditorModal 
      ref="edit-question-group-modal"
      :question_form_id="selected_question_form_id"
      @created="created"
      @updated="updated"
      @cancelled="cancelled"
    />

    <div class="px-4">
      <m-row>
        <m-col lg="12" class="d-flex justify-end">
          <memlist-icon-button
            icon="menu-icon flaticon2-plus"
            text="Skapa enkät"
            variant="primary"
            @click="create_question_form"
          />
        </m-col>
      </m-row>
    </div>
    
    <m-row>
      <m-col cols="4">
        <div class="bottom-alignment">
          <strong>Antal rader:</strong> {{ total_rows }}
        </div>
      </m-col>
      
    </m-row>

    <memlist-static-table
      id="question-group-table"
      style="width: 100%; table-layout: fixed;"
      class="table-striped"
      :fields="headers"
      :items="items"
      head-variant="light"
      ref="event-stable"
    >
      <template #cell(actions)="data">
        <memlist-table-button class="mr-3" @click="edit_form(data.item)" svg="/assets/svg/pencil-square.svg" :tooltip="'Redigera'" />
        <memlist-table-button class="mr-3" @click="delete_form(data.item.id)" svg="/assets/svg/trash2.svg" :tooltip="'Radera'" />
      </template>
    </memlist-static-table>

  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import QuestionFormEditorModal from '@/view/pages/ml/questions/QuestionFormEditorModal.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'QuestionFormTable',
  components: {
    QuestionFormEditorModal
  },
  data() {
    return {
      selected_question_form_id: null,
      items: [],
      filters: {},
      total_rows: 0,
      current_page: 1,
      per_page: 10,
      search: null
    };
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies', 'periods', 'settings']),
  
    headers() {
      return [
        { label: 'ID', sortable: true, key: 'id', tdClass: 'td-overflow', thClass: 'td-overflow' },
        { label: 'Namn', sortable: true, key: 'name', tdClass: 'td-overflow', thClass: 'td-overflow' },
        { label: 'Skapad', sortable: true, key: 'created_at', tdClass: 'td-overflow', thClass: 'td-overflow', formatter: (_, __, item) => dayjs(item.created_at).format('YYYY-MM-DD') },
        { 
          label: this.$t('COMMON.ACTIONS'), 
          key: 'actions', 
          sortable: false,
          tdClass: 'text-right',
          thClass: 'text-right',
        }
      ];
    }
  },
  watch: {
    currentCompanyId() {
      this.fetch_items();
    },
  },
  methods: {
    async fetch_items() {
      try {
        const response = await axios.get(`/question_form/company/${this.currentCompanyId}`);

        if (response.status === 403) {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.LACK_PERMISSION'));
          return;
        }

        this.items = response.data;
        this.total_rows = response.data.length;
      } catch (error) {
        console.error("Error fetching question forms:", error);
      }
    },

    created(item) {
      this.items.push(item);
      this.total_rows = this.items.length;
    },

    updated(item) {
      const index = this.items.findIndex(i => i.id === item.id);

      if (index !== -1) {
        this.items[index] = item;
      }

      this.items = [ ...this.items ];

      this.selected_question_form_id = null;
    },

    cancelled() {
      this.selected_question_form_id = null;
    },

    create_question_form() {
      this.selected_question_form_id = null;
      this.$refs['edit-question-group-modal'].show();
    },

    edit_form(item) {
      this.selected_question_form_id = item.id;

      this.$refs['edit-question-group-modal'].show();
    },

    async delete_form(id) {
      if (!confirm('Är du säker på att du vill radera denna enkät?')) return;

      try {
        const res = await axios.delete(`/question_form/${id}`);

        if (res.status === 403) {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.LACK_PERMISSION'));
          return;
        }
        
        this.items = this.items.filter(item => item.id !== id);
        this.total_rows = this.items.length;
      } catch (error) {
        console.error("Error deleting question form:", error);
      }
    },

    refresh() {
      this.fetch_items();
    }
  },
  mounted() {
    this.fetch_items();
  }
};
</script>

<style scoped>
.container {
  padding: 20px;
}
</style>
